export default __webpack_public_path__ + "static/media/HumidityImg.f3f906f2.jpg";